// code not in use anymore...
/*var InfoTextCtrl = function ($scope, $uibModalInstance, modalVal) {
    // $uibModalInstance: same from  from ui bootstrap
    console.log('Hello init!');
    // modalVal is the init modal value passed via directive
    console.log(modalVal);

    // your code
    $scope.comments = modalVal;

    $scope.ok = function() {
        $uibModalInstance.close(this.comments); // returnValue
    };

    $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };
}
InfoTextCtrl.$inject = ['$scope', '$uibModalInstance','params'];
angular.module('app').controller('InfoTextCtrl',InfoTextCtrl);
*/